var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMerchantactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2511",
    "data-name": "Rectangle 2511",
    width: 24,
    height: 24,
    transform: "translate(19 339)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4762",
    "data-name": "Mask Group 4762",
    transform: "translate(-19 -339)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "supermarket",
    transform: "translate(2.51 287.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8240",
    "data-name": "Path 8240",
    d: "M37.209,58.764l-.68-1.477A2.213,2.213,0,0,0,34.519,56H22.893a2.213,2.213,0,0,0-2.01,1.287l-.68,1.477a2.2,2.2,0,0,0-.2.925A2.092,2.092,0,0,0,22.066,61.9a2.213,2.213,0,0,0,2.213-2.213,2.213,2.213,0,0,0,4.427,0,2.213,2.213,0,0,0,4.427,0A2.213,2.213,0,0,0,35.345,61.9a2.092,2.092,0,0,0,2.066-2.213A2.2,2.2,0,0,0,37.209,58.764Z",
    transform: "translate(-0.215)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_830",
    "data-name": "Line 830",
    y2: 8.979,
    transform: "translate(21.26 61.776)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_831",
    "data-name": "Line 831",
    x2: 18,
    transform: "translate(19.49 71.378)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_832",
    "data-name": "Line 832",
    y1: 6.028,
    transform: "translate(35.72 61.776)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8241",
    "data-name": "Path 8241",
    d: "M140,301.9v-4.427A1.476,1.476,0,0,1,141.476,296h1.476a1.476,1.476,0,0,1,1.476,1.476V301.9",
    transform: "translate(-115.789 -231.147)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_833",
    "data-name": "Line 833",
    x2: 1,
    transform: "translate(31.49 66.378)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchantactive);
export default __webpack_public_path__ + "static/media/merchantactive.89124eb651a61987508920666bdc66c0.svg";
export { ForwardRef as ReactComponent };